import { Programs } from "../api";
import { setModalProgramEditClosed } from "../actions/modals";
import axios from "../api/axios";

export const fetchPrograms = () => (dispatch, getStore) => {
  dispatch(setProgramsLoading());

  return axios
    .get("api/programmes")
    .then((response) => {
      const array = response.data.data;
      if (array.length > 0) {
        array.forEach((program) => {
          dispatch(setPrograms(program));
        });
      }
      dispatch(setProgramsLoaded());
    })
    .catch((e) => {
      console.log(e);
      dispatch(setProgramsError());
    });
};

export const savePrograms =
  (program, event, formApi) => (dispatch, getStore) => {
    dispatch(setProgramEditSaving());

    switch (program.payment_type) {
      case "Credit Card":
        program.donation_batch_number = "CC";
        program.donation_batch_type = "CC";
        break;

      case "Direct Debit":
        program.donation_batch_number = "DD";
        program.donation_batch_type = "DD";
        break;

      default:
        program.donation_batch_number = "Direct Deposit";
        program.donation_batch_type = "Direct Deposit";
    }

    Programs.save(program)
      .then((response) => {
        if (response.result !== "success") {
          throw response.errors;
        }

        // Update the store with the new program info, causing a render
        dispatch(setPrograms(program));

        // Show the success button.
        dispatch(setProgramEditSuccess());

        // After 1 second, turn the success button back to a normal save button.
        setTimeout(function () {
          dispatch(setProgramEditDone());

          // Close the program edit modal
          setTimeout(function () {
            dispatch(setModalProgramEditClosed());
          }, 250);
        }, 1000);

        // Save the program update event to Google Analytics
        if (typeof window.ga !== "undefined") {
          window.ga("send", "event", "Program Updated", "Program Updated");
        }
      })
      .catch((donationErrors) => {
        console.error("-- Donation server validation error!", donationErrors);

        // Map the errors onto the form.
        Object.keys(donationErrors).map((field) =>
          formApi.setError(field, donationErrors[field].split("||"))
        );

        // Show the error button.
        dispatch(setProgramEditError());
      });
  };

export const deletePrograms = (donation_id) => (dispatch, getStore) => {
  // This currently does nothing as the link that deletes the program currently
  // opens the help modal with info on how to delete.
};

export const setPrograms = (programs) => ({
  type: "SET_PROGRAMS",
  programs,
});

export const setProgramsLoading = (programs) => ({
  type: "SET_PROGRAMS_LOADING",
});

export const setProgramsLoaded = () => ({
  type: "SET_PROGRAMS_LOAD_COMPLETED",
});

export const setProgramsError = (message = "Sorry, an error occurred") => ({
  type: "SET_PROGRAMS_ERROR",
  message,
});

export const setSelectedProgram = (id = null) => ({
  type: "SET_SELECTED_PROGRAM",
  id,
});

export const setProgramEditSaving = () => ({
  type: "SET_PROGRAM_EDIT_SAVING",
});

export const setProgramEditSuccess = (
  message = "Thank you, your save was successful"
) => ({
  type: "SET_PROGRAM_EDIT_SUCCESS",
  message,
});

export const setProgramEditError = (message = "Sorry, an error occurred") => ({
  type: "SET_PROGRAM_EDIT_ERROR",
  message,
});

export const setProgramEditDone = () => ({
  type: "SET_PROGRAM_EDIT_DONE",
});
